
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 10a4 4 0 100-8 4 4 0 000 8z","stroke":"currentColor","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M1.938 13.5a7 7 0 0112.124 0","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    